<div class="login-page">
  <form [formGroup]="inputForm" (ngSubmit)="submit()">
    <div class="login-box" [ngClass]="{ shake : loginInvalid  }">
      <div class="login-logo">
        <b>PASSWORD Change</b>
      </div>
      <div class="card">
        <div class="card-body login-card-body">
          <div class="row mt-10">
            <div class="col">
              <span class="error small">{{ errorMessage ? errorMessage : '&nbsp;'}}</span>
            </div>
          </div>
          <div class="row form-group">
            <div class="input-group mb-3">
              <input type="password"
                class="form-control"
                id="password"
                formControlName="password"
                placeholder="password"
                autocomplete="off" />
              <div class="input-group-append">
                <div class="input-group-text">
                  <span class="fas fa-lock"></span>
                </div>
              </div>
            </div>
            <div class="input-group mb-3">
              <input type="password"
                class="form-control"
                id="password"
                formControlName="newPassword"
                placeholder="new password"
                autocomplete="off" />
              <div class="input-group-append">
                <div class="input-group-text">
                  <span class="fas fa-lock"></span>
                </div>
              </div>
            </div>            
            <div class="input-group mb-3">
              <input type="password"
                class="form-control"
                id="newPasswordConfirm"
                formControlName="newPasswordConfirm"
                placeholder="password confirm"
                autocomplete="off" />
              <div class="input-group-append">
                <div class="input-group-text">
                  <span class="fas fa-lock"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="offset-8 col-4">
              <button type="submit" class="btn btn-primary btn-block">
                <span *ngIf="!submitted"><i class="fas fa-key"></i></span>
                <span *ngIf="submitted"
                  ><i class="fas fa-spinner fa-spin"></i
                ></span>
                <span>Submit</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
